import React from 'react';
import * as Icons from 'lucide-react';
import { Mountain, Coffee, Trophy } from 'lucide-react';
import { DEFAULT_SITE_CONTENT, mergeContent } from '@/constants/defaultSiteContent';

const About = ({ content }) => {
  const c = mergeContent(DEFAULT_SITE_CONTENT.about, content || {});
  const fallbackIcons = [Mountain, Coffee, Trophy];

  return (
    <section id="about" className="relative py-16 sm:py-28 overflow-hidden">
      {/* Immersive background */}
      <div className="absolute inset-0 z-0">
        <img src={c.bg_image_url} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0F2E23]/95 via-[#0F2E23]/85 to-[#0F2E23]/75" />
      </div>

      <div className="relative z-10 max-w-[1360px] mx-auto grid lg:grid-cols-[minmax(0,1fr)_minmax(0,0.85fr)] gap-8 sm:gap-10 lg:gap-14 items-center px-4 sm:px-6">
        <div className="text-[#F5F0E6]">
          <div className="text-[10px] sm:text-[11px] tracking-[0.28em] text-[#F5C86A] font-semibold">
            {c.eyebrow}&nbsp;&nbsp;<span className="inline-block w-12 sm:w-16 h-px bg-[#F5C86A]/60 align-middle" />
          </div>
          <h2 className="mt-3 font-display text-[34px] sm:text-[58px] leading-[1.04] tracking-tight">
            {c.heading_top}<br/>
            <span className="italic text-[#F5C86A]" style={{ fontFamily: 'Great Vibes, cursive' }}>{c.heading_script}</span>
          </h2>
          <p className="mt-4 sm:mt-6 max-w-lg text-[14px] sm:text-[15px] leading-relaxed text-[#F5F0E6]/85">{c.body}</p>

          <div className="mt-6 sm:mt-8 grid grid-cols-3 gap-3 sm:gap-4 max-w-md">
            {(c.stats || []).map((s, i) => {
              const IconComp = Icons[s.icon] || fallbackIcons[i] || Mountain;
              return <Stat key={i} icon={IconComp} label={s.label} sub={s.sub} />;
            })}
          </div>
        </div>

        <div className="relative rounded-xl overflow-hidden h-[240px] sm:min-h-[440px] shadow-[0_40px_100px_rgba(0,0,0,0.5)] ring-1 ring-[#F5C86A]/30">
          <img src={c.inset_image_url} alt={c.inset_alt || ''} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0F2E23]/70 via-transparent to-transparent" />
          <div className="absolute left-4 sm:left-5 bottom-4 sm:bottom-5">
            <div className="text-[#F5F0E6] text-[9px] sm:text-[10px] tracking-[0.32em] font-semibold">{c.inset_label}</div>
            <div className="text-[#F5F0E6]/85 text-[9px] sm:text-[10px] tracking-[0.32em]">{c.inset_sub}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Stat = ({ icon: Icon, label, sub }) => (
  <div className="flex flex-col items-start gap-1.5 sm:gap-2">
    <span className="inline-flex w-9 h-9 sm:w-10 sm:h-10 items-center justify-center rounded-full bg-[#F5C86A]/15 border border-[#F5C86A]/40 text-[#F5C86A]">
      <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4" strokeWidth={1.6} />
    </span>
    <div>
      <div className="text-[9px] sm:text-[10px] tracking-[0.24em] sm:tracking-[0.28em] font-semibold text-[#F5C86A]">{label}</div>
      <div className="text-[10px] sm:text-[11px] text-[#F5F0E6]/80">{sub}</div>
    </div>
  </div>
);

export default About;
